import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next'

const UseSnus = () => {
  const { t } = useTranslation()

  const useSnus = '../../../images/use-snus.jpg'

  return (
    <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] mt-6 h-full mx-auto">
      {/* <div className="w-full">
        <div className="text-center flex justify-center items-center flex-col text-2xl text-slate-600 font-bold relative pb-[25px]">
          <h2>Top Category</h2>
          <div className="w-[100px] h-[2px] bg-[#059473] mt-4"></div>
        </div>
      </div> */}
      <div className="w-[20%] md:w-[80%] sm:w-[90%] lg:w-[90%]">
        <h2 className="text-lg font-bold p-2 rounded-tl-lg rounded-tr-lg  text-slate-600">
          {t('home.how_use')}{' '}
        </h2>
      </div>

      <div className="border-t py-4 sm:w-full md:w-full mx-auto relative  gap-4">
        <div className="flex  item-center justify-center w-full sm:w-full  p-8">
          <img src={useSnus} alt="useSnus" className="w-[95%]  " />
        </div>
        <p className="text-justify px-6">{t('home.about_snus')}</p>
      </div>
      <div className="w-full sm:w-full mt-3">
        <h2 className="text-lg font-bold p-2 rounded-tl-lg rounded-tr-lg  text-slate-600">
          {t('home.how_to_use')}{' '}
        </h2>
        <div className="border-t py-4 sm:w-full md:w-full  mx-auto relative  gap-4">
          <ul className="list-decimal list-inside text-justify px-8 py-4 space-y-2">
            <li>{t('home.use_1')}</li>
            <li>{t('home.use_2')}</li>
            <li>{t('home.use_3')}</li>
            <li>{t('home.use_4')}</li>
          </ul>

          <p className="text-justify p-4">{t('home.use_info')}</p>
        </div>
      </div>
    </div>
  )
}

export default UseSnus
